export const sectionTitle = "What is Cledar?";

export const sectionDescription =
  "Led by former CERN domain leaders, Cledar is a team of data scientists, technology experts, and software engineers united by a desire to achieve big things with big data. We design, build, and refine data-driven applications that will help you to make sense of – and thrive – in the world around you.";

